import type { Shadows } from '@mui/material';

const shadows: Shadows = [
  'none',
  // h-offset v-offset blur spread color |inset|initial|inherit
  // rgba(26, 26, 26) is grayscale0
  '0px 2px 3px rgba(26, 26, 26, 0.24)', // 1
  '0px 2px 3px rgba(26, 26, 26, 0.2357)', // 2
  '0px 2px 4px rgba(26, 26, 26, 0.2313)', // 3
  '0px 2px 4px rgba(26, 26, 26, 0.227)', // 4
  '0px 2px 4px rgba(26, 26, 26, 0.2226)', // 5
  '0px 2px 5px rgba(26, 26, 26, 0.2183)', // 6
  '0px 3px 5px rgba(26, 26, 26, 0.2139)', // 7
  '0px 3px 5px rgba(26, 26, 26, 0.2096)', // 8
  '0px 3px 6px rgba(26, 26, 26, 0.2052)', // 9
  '0px 3px 6px rgba(26, 26, 26, 0.2009)', // 10
  '0px 3px 6px rgba(26, 26, 26, 0.1965)', // 11
  '0px 3px 7px rgba(26, 26, 26, 0.1922))', // 12
  '0px 3px 7px rgba(26, 26, 26, 0.1878)', // 13
  '0px 3px 8px rgba(26, 26, 26, 0.1835)', // 14
  '0px 3px 8px rgba(26, 26, 26, 0.1791)', // 15
  '0px 3px 8px rgba(26, 26, 26, 0.1748)', // 16
  '0px 3px 9px rgba(26, 26, 26, 0.1704)', // 17
  '0px 3px 9px rgba(26, 26, 26, 0.1661)', // 18
  '0px 4px 9px rgba(26, 26, 26, 0.1617)', // 19
  '0px 4px 10px rgba(26, 26, 26, 0.1574)', // 20
  '0px 4px 10px rgba(26, 26, 26, 0.153)', // 21
  '0px 4px 10px rgba(26, 26, 26, 0.1487)', // 22
  '0px 4px 11px rgba(26, 26, 26, 0.1443)', // 23
  '0px 4px 11px rgba(26, 26, 26, 0.14)', // 24
];

export { shadows };
